<template>
  <BaseModal
    class="submit-question-modal"
    color="dark-grey"
    rounded
    dropShadow
    @background-clicked="$emit('close')"
  >
    <header class="submit-question-modal__header">
      <h2 class="submit-question-modal__header-title">
        {{ headerText }}
      </h2>
    </header>
    <section class="submit-question-modal__body">
      <form
        @submit.prevent="submitQuestion"
        class="submit-question-modal__body-form"
      >
        <FormTextarea
          id="question"
          name="question"
          v-model="question"
          :label-text="labelText"
          :placeholder="placeHolderText"
          has-character-count
          :max-length="3000"
          :error-message="questionError"
          class="submit-question-modal__body-form-textarea"
        />
        <div class="submit-question-modal__body-controls">
          <BaseButton
            type="submit"
            class="submit-question-modal__body-controls-button"
            :disabled="!isFormValid"
          >
            SUBMIT
          </BaseButton>
          <BaseButton
            type="button"
            color="charcoal"
            class="submit-question-modal__body-controls-button"
            @click="$emit('close')"
          >
            CANCEL
          </BaseButton>
        </div>
      </form>
    </section>
  </BaseModal>
</template>

<script>
  import BaseModal from '~/components/base/BaseModal.vue';
  import BaseButton from '~/components/base/BaseButton.vue';
  import FormTextarea from '~/components/form/FormTextarea.vue';
  
  export default {
    name: 'SubmitAQuestionModal',
    emits: ['close'],
    components: {
      BaseModal,
      BaseButton,
      FormTextarea,
    },
    props: {
      webinar: {
        type: Object,
        required: true,
      },
      authUser: {
        type: Object,
        required: true,
      },
      isQa: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      question: '',
      questionError: '',
    }),
    computed: {
      isFormValid() {
        if (/^\s*$/.test(this.question)) {
          return false;
        }
        return !this.questionError;
      },
      characterCount() {
        return this.question.length;
      },
      headerText() {
        if(this.isQa) {
          return `Hi, ${this.authUser.first_name.toUpperCase()}! What’s your Trends Report™ question?`
        }
        return `Hi, ${this.authUser.first_name.toUpperCase()}! What's your headline in question?`;
      },
      labelText() {
        if(this.isQa) {
          return 'Your Question:';
        }
        return 'Your Headline:';
      },
      placeHolderText() {
        if(this.isQa) {
          return 'Please type your question in the space provided. Our expert team will review your question and provide an answer in our weekly Q&A video recordings. ';
        }
        return 'Please type your headline with the source, a link if possible, and any questions you have pertaining to the article here, and we will be in touch with you shortly.';
      }
    },
    methods: {
      async submitQuestion() {
        try {
          this.question = this.question.trim();
          this.validateQuestion();
          if (!this.isFormValid) return;
          await axios.post('/user-questions', {
            question: this.question,
            questionable_id: this.webinar.id,
            questionable_type: 'Webinar',
            isQa: this.isQa,
          });
          this.$emit('close', { sentSuccessfully: true });
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      validateQuestion() {
        this.questionError = '';
        if (!this.question) {
          this.questionError = 'Question is required';
          return;
        } else if (this.question.length > 3000) {
          this.questionError = 'Question cannot be more than 3000 characters';
          return;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .submit-question-modal {
    :deep(.base-modal__content) {
      display: flex;
      flex-direction: column;
      gap: 32px;
    }

    &__header {
      text-align: center;

      &-title {
        color: var(--itr-blue);
        font-size: 30px;
        font-weight: 800;
        width: 100%;
        text-align: center;
        margin: 0;
        line-height: 40px;
      }

      &-description {
        color: var(--itr-charcoal);
        text-align: left;
        font-weight: 400;
        line-height: 26px;
        margin: 0;
        font-size: 16px;
      }
    }

    &__body {
      &-form {
        display: flex;
        flex-direction: column;

        &-textarea :deep(.base-textarea) {
          min-height: 175px;
        }
      }
      &-controls {
        display: flex;
        justify-content: center;
        gap: 32px;
        margin-top: 32px;

        &-button {
          width: 100%;
          max-width: 225px;
          padding: 4px 32px;
        }
      }
    }
  }
</style>
